import http from 'hub-http/clients/apiClient';
export function fetchCallsV1Settings() {
  return http.get('/calls/v1/settings');
}